export enum CombinedFamilyType {
    Home = 'casa',
    Bike = 'Bici',
}
